import React, { lazy, Suspense } from "react";
const HeroScene = lazy(() => import("../three/HeroScene"));

const LOGO_URL = "/munnexa-logo.png";

export default function Hero({ onOpenChat }) {
  const enter = () => {
    const el = document.getElementById("revenue-engine");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="hero" className="relative w-full min-h-[100svh] overflow-hidden pt-28 pb-12" data-testid="hero-section">
      {/* 3D scene as background */}
      <div className="absolute inset-0 z-0">
        <Suspense fallback={<div className="w-full h-full grid-bg" />}>
          <HeroScene />
        </Suspense>
      </div>

      {/* Background gradient veil to keep text legible */}
      <div className="absolute inset-0 z-[1] pointer-events-none" style={{
        background: "radial-gradient(ellipse 60% 50% at 50% 65%, rgba(5,8,22,0.85) 0%, rgba(5,8,22,0.65) 40%, transparent 80%)"
      }} />
      <div className="absolute inset-0 z-[1] grid-bg opacity-40 pointer-events-none" />

      {/* Content stack — logo on top, then headline, fully above 3D */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 max-w-5xl mx-auto">
        {/* Floating Logo — sits above everything else with breathing space */}
        <div className="animate-float pointer-events-none mb-8 sm:mb-10" data-testid="hero-logo">
          <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl overflow-hidden ring-1 ring-white/15 glow-magenta">
            <img src={LOGO_URL} alt="MUNNEXA Logo" className="w-full h-full object-cover" />
          </div>
        </div>

        <p className="font-mono text-[11px] sm:text-xs tracking-[0.5em] text-cyan-300/90 mb-4" data-testid="hero-overline">
          ◆ WELCOME TO MUNNEXA
        </p>
        <h1 className="text-4xl sm:text-6xl lg:text-7xl font-[Outfit] font-bold leading-[0.95]" data-testid="hero-title">
          The <span className="text-gradient">Next Era</span> of
          <br />
          AI Business Growth.
        </h1>
        <p className="mt-5 max-w-2xl text-white/75 text-base sm:text-lg leading-relaxed" data-testid="hero-subtitle">
          Enter the future of business. MUNNEXA fuses AI, automation, and revenue engineering into a single living ecosystem — designed to scale companies beyond what was possible yesterday.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <button
            onClick={enter}
            data-testid="hero-enter-experience-btn"
            className="btn-gradient rounded-full px-7 py-3.5 text-base"
          >
            Enter Experience  →
          </button>
          <button
            onClick={() => onOpenChat && onOpenChat()}
            data-testid="hero-talk-to-ai-btn"
            className="btn-ghost rounded-full px-7 py-3.5 text-base"
          >
            Talk to NEXA AI
          </button>
        </div>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 w-full">
          {[
            ["+412%", "Avg. ROI"],
            ["7.3x", "Lead growth"],
            ["24/7", "AI Operators"],
            ["18+", "Industries"],
          ].map(([v, l], i) => (
            <div key={l} className="glass rounded-xl px-3 py-3" data-testid={`hero-stat-${i}`}>
              <div className="text-xl sm:text-2xl font-[Outfit] font-bold text-gradient-cyan">{v}</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-white/55 mt-0.5">{l}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 mt-10 text-center font-mono text-[10px] tracking-[0.4em] text-white/40">
        SCROLL ↓ TO BOOT SYSTEM
      </div>
    </section>
  );
}
